export { default } from './jssPreset';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/jssPreset/index.js
// module id = 311
// module chunks = 0